import SalesOrderStatusBadge from '#/modules/crmMgmt/salesOrder/components/SalesOrderStatusBadge';
import { formatDateOrDash } from '#/utils/date';

function dash(value) {
  if (value === null || value === undefined || value === '') {
    return '-';
  }
  return value;
}

function formatListDate(value) {
  if (value == null || value === '') {
    return '-';
  }
  return formatDateOrDash(String(value).trim().slice(0, 10));
}

function formatCustomerLabel(row) {
  const customer = row?.customer;
  if (!customer) {
    return '-';
  }
  const label = [customer.code, customer.name].filter(Boolean).join(' - ');
  return label || '-';
}

/** Block A：僅狀態 */
export const salesOrderSideMsgStatusBlock = {
  fields: [
    {
      key: 'status',
      label: '狀態',
      render: (row) => (
        <div className="side_msg-row">
          <h3>狀態</h3>
          {row?.status
            ? <SalesOrderStatusBadge status={row.status} size="sm" />
            : <p>-</p>}
        </div>
      ),
    },
  ],
};

/** Block C：其餘欄位（唯讀） */
export const salesOrderSideMsgDetailBlock = {
  fields: [
    { label: '銷貨單號', value: 'salesOrderNo' },
    { label: '客戶訂單號', value: (row) => dash(row?.customerOrderNo) },
    { label: '客戶', value: formatCustomerLabel },
    {
      label: '預交日',
      value: (row) => formatDateOrDash(row?.plannedShipDate),
    },
    {
      label: '明細數',
      value: (row) => dash(row?.lineCount),
    },    {
      label: '建立日',
      value: (row) => formatListDate(row?.record?.createdAt),
    },
    { label: '備註', value: (row) => dash(row?.remark) },
  ],
};

export const salesOrderSideMsgBlocks = [
  salesOrderSideMsgStatusBlock,
  salesOrderSideMsgDetailBlock,
];
